import React, { useEffect, useState } from 'react';
import './CommunityReviews.scss';
import { http, FxHumanDateDisplay, useNavigationService, formatService, FxDate } from '../../fx-core';
import Rating from '@material-ui/lab/Rating';
import PersonIcon from '@material-ui/icons/Person';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Typography from '@material-ui/core/Typography';
import { Link, Button, Dialog } from '@material-ui/core';
import ConfirmDialog from '../../ConfirmDialog/ConfirmDialog';

const CommunityReviews = (props: any) => {
    const { routeData, back } = useNavigationService();

    const currentDate = formatService.getCurrentDateForServer();
    let defaultFilter = {
        fromDate: formatService.getYearStartDate(),
        toDate: currentDate
    };
    const [filters, setFilters] = useState(defaultFilter);
    const [reviewList, setReviewList] = useState([]);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [message, setMessage] = useState("");
    const [selReview, setSelReview] = useState({});

    const handleInputChange = (item) => {
        handleFilterChange({ [item.name]: item.value });
        if (item.name == "fromDate") {
            getCommunityReviews({ "fromDate": formatService.getDateStringForServer(item.value), "toDate": filters.toDate });
        }
        else if (item.name == "toDate") {
            getCommunityReviews({ "toDate": formatService.getDateStringForServer(item.value), "fromDate": filters.fromDate });
        }
    };

    const handleFilterChange = (data) => {
        setFilters(prevState => {
            return { ...prevState, ...data }
        });
    };

    const getCommunityReviews = (data: any) => {
        let inputData = {
            communityId: routeData.communityId,
            fromDate: data.fromDate,
            toDate: data.toDate
        }
        let apiOptions: any = {
            url: `review/query`,
            data: inputData
        };
        http.post(apiOptions).then(res => {
            getCommunityReviewsCallBack(res);
        });
    }

    const getCommunityReviewsCallBack = (res) => {
        setReviewList(res.data);
    }

    const showConfirmDialog = (item) => {
        const context = item.reviewStatusId == 2 ? "inactive" : "active";
        const message = "Are you sure to " + context + " this review?";
        setMessage(message);
        setSelReview(item);
        setConfirmOpen(true);
    }

    const handleDialogClose = () => {
        setConfirmOpen(false);
        setMessage("");
        setSelReview({});
    }

    const onConfirmCallback = () => {
        const selItem: any = selReview;
        selItem.reviewStatusId = selItem.reviewStatusId == 2 ? 3 : 2; // 2-Approved, 3-Rejected        
        handleDialogClose();
        updateReviewStatus(selItem);
    }

    const updateReviewStatus = (data) => {
        let apiOptions: any = {
            url: `review/updatestatus`,
            data: data
        };
        http.put(apiOptions).then(res => {
            updateReviewStatusCallBack(res);
        });
    }

    const updateReviewStatusCallBack = (res) => {
        getCommunityReviews(filters);
    }

    const navToBack = () => {
        back();
    }

    useEffect(() => {
        getCommunityReviews(filters);
    }, []);

    return (
        <div className="community-reviews-ui pt-4 mt-3">
            <div className="title-font custom-head pl-4 pt-5">
                <Breadcrumbs aria-label="breadcrumb">
                    <Link color="primary" className="custom-link pointer breadcrumbs-style" onClick={navToBack}>
                        <b>{routeData.communityName}</b>
                    </Link>
                    <Typography color="primary" className="breadcrumbs-style">Reviews</Typography>
                </Breadcrumbs>
            </div>
            <div className='row my-4 mx-2'>
                <div className="col-3">
                    <FxDate
                        name="fromDate"
                        value={filters.fromDate}
                        variant="outlined"
                        label="From Date"
                        fullWidth
                        size="small"
                        onValueChange={handleInputChange}
                    />
                </div>
                <div className="col-3">
                    <FxDate
                        name="toDate"
                        value={filters.toDate}
                        variant="outlined"
                        label="To Date"
                        fullWidth
                        size="small"
                        onValueChange={handleInputChange}
                    />
                </div>
            </div>
            <div className='mx-2 pt-1 col-12 alignbox'></div>
            <div>
                {
                    reviewList.length == 0 &&
                    <div className="px-5 py-5 font-20 mx-5 text-center">
                        No Reviews Found
                    </div>
                }
            </div>
            <div>
                {
                    reviewList.map((item: any) => (
                        <div className="row mx-2 pt-1 col-12 alignbox">
                            <div className="col-8">
                                {item.reviewComment}
                            </div>

                            <div className="col-4">
                                <span className='float-right'>
                                    <Rating name="read-only" value={item.rating} readOnly />
                                </span>
                            </div>

                            <div className="col-8">
                                <span>
                                    <PersonIcon />
                                    {item.userName}
                                </span>
                            </div>

                            <div className="col-2">
                                <span className='bold-text'>
                                    <FxHumanDateDisplay value={item.ratingDate} displayType="datetime" />
                                </span>
                            </div>
                            <div className='col-2'>
                                <span className='float-right'>
                                    <Button variant='outlined' size='small' className='button-style'
                                        onClick={() => showConfirmDialog(item)}>
                                        {
                                            item.reviewStatusId == 2 &&
                                            <span>InActive</span>
                                        }
                                        {
                                            item.reviewStatusId == 3 &&
                                            <span>Active</span>
                                        }
                                    </Button>
                                </span>
                            </div>
                        </div>
                    ))
                }
            </div>
            <Dialog
                open={confirmOpen}
                maxWidth="sm"
                fullWidth
                onClose={handleDialogClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <ConfirmDialog message={message} handleDialogClose={handleDialogClose} onConfirmCallback={onConfirmCallback} />
            </Dialog>
        </div>
    );

}

export default CommunityReviews;